export const Chervyen = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.858036397539422, 53.57217786506459],
            [28.856955975171502, 53.577310150538835],
            [28.855170410051016, 53.585525567528066],
            [28.851599280708, 53.59294457187082],
            [28.846242587143024, 53.595858824408765],
            [28.835529199114603, 53.60115695026627],
            [28.831511678940785, 53.60460037546636],
            [28.830618896380372, 53.61069190209918],
            [28.83508280828363, 53.61545857130983],
            [28.835529199114603, 53.62048947147383],
            [28.832404461501028, 53.626578706108205],
            [28.819905509250248, 53.63504922328298],
            [28.80562099277728, 53.641400995686695],
            [28.79312204052667, 53.65066228216091],
            [28.78687256440128, 53.65674716361815],
            [28.785979781841036, 53.664682644801246],
            [28.781515869937778, 53.67182330103748],
            [28.7761591763728, 53.676583065926536],
            [28.774820002981414, 53.68134229358333],
            [28.774820002981414, 53.686365338659755],
            [28.773480829590255, 53.69614533994502],
            [28.769016917687168, 53.701959398165116],
            [28.75964270394826, 53.70697998446951],
            [28.751607662702384, 53.70935794769832],
            [28.744019013185778, 53.71199997179684],
            [28.734198407717543, 53.71490600646359],
            [28.732859234326156, 53.718604305654424],
            [28.74000149301179, 53.719925048104415],
            [28.74491179574602, 53.720717473560285],
            [28.746697359968152, 53.724943490852866],
            [28.7529468360936, 53.72916908293797],
            [28.758749921388016, 53.73233799845303],
            [28.771248873638626, 53.738147056883236],
            [28.77392722042123, 53.74553924283157],
            [28.77214165619904, 53.75319406500131],
            [28.76990970024741, 53.758736340923065],
            [28.76812413602528, 53.764805613739156],
            [28.76589218007365, 53.769818699446375],
            [28.760535486508502, 53.771665475096825],
            [28.754286010383055, 53.77483118658978],
            [28.7529468360936, 53.779315536025194],
            [28.756071574605414, 53.783008169944196],
            [28.764106614952993, 53.78722792526804],
            [28.767231353464865, 53.7914472556763],
            [28.764553006682263, 53.79434779946456],
            [28.75964270394826, 53.79645715992473],
            [28.75517879204517, 53.80093919847019],
            [28.74937570764905, 53.80542075799775],
            [28.744019013185778, 53.807529561537365],
            [28.73866231962063, 53.807529561537365],
            [28.7337520168864, 53.80621157168929],
            [28.729288105881835, 53.80436631671523],
            [28.72437780314766, 53.804102701853026],
            [28.720360282075546, 53.80779315432267],
            [28.722592238027005, 53.81148328194678],
            [28.727948931592152, 53.81385533573268],
            [28.7337520168864, 53.81543662999246],
            [28.74000149301179, 53.81728139771491],
            [28.747143751697422, 53.820707180160355],
            [28.750714881040437, 53.82492314324918],
            [28.750714881040437, 53.829665594267055],
            [28.745358186576993, 53.832563494665806],
            [28.739555102180873, 53.832300057652446],
            [28.734198407717543, 53.82913868160051],
            [28.727948931592152, 53.827294435867316],
            [28.71946750041343, 53.8267674933748],
            [28.713664415119183, 53.827294435867316],
            [28.702058245428816, 53.832300057652446],
            [28.69089846656925, 53.83862209291328],
            [28.681077861101187, 53.844416453909446],
            [28.681077861101187, 53.849156698020636],
            [28.686434554666164, 53.85494960115824],
            [28.69446959591204, 53.858372303570945],
            [28.701611853699376, 53.86469040268946],
            [28.70875411238501, 53.866533002237816],
            [28.720360282075546, 53.87048115579836],
            [28.729734496712638, 53.87232350028313],
            [28.738215928789657, 53.87495527951927],
            [28.74312623152366, 53.87837634551721],
            [28.744465404915047, 53.8812708749449],
            [28.74312623152366, 53.884954531638755],
            [28.737769537060387, 53.88653314221665],
            [28.729288105881835, 53.88653314221665],
            [28.72125306463579, 53.883638977108546],
            [28.7150035885104, 53.88153400385522],
            [28.70920050411445, 53.88074461162722],
            [28.70250463625979, 53.88048147774896],
            [28.69402320418277, 53.882849624624725],
            [28.69223763996041, 53.88784860567034],
            [28.69223763996041, 53.89337309938122],
            [28.69089846656925, 53.89758174768167],
            [28.687327337226407, 53.90047494744675],
            [28.68197064366143, 53.90257896694777],
            [28.66902529968138, 53.90310495539899],
            [28.657419129990785, 53.90547182068315],
            [28.656526347430543, 53.90967924990014],
            [28.65920469511144, 53.91493794137227],
            [28.66723973545919, 53.91861863109875],
            [28.674828384975797, 53.9194073080767],
            [28.685095381274778, 53.9180928379937],
            [28.691791249129437, 53.916778326527265],
            [28.698933506916774, 53.917041231919654],
            [28.710093285776395, 53.919670196915774],
            [28.71187885089688, 53.92229899638119],
            [28.710093285776395, 53.92571618759098],
            [28.70295102798906, 53.92781893573709],
            [28.70071907203743, 53.93071004140859],
            [28.705182983042164, 53.93596608395376],
            [28.704736592211248, 53.93938215684517],
            [28.697594333525615, 53.941484216491176],
            [28.691791249129437, 53.94174696630154],
            [28.684202599612888, 53.94384890679481],
            [28.680185078540774, 53.94805247005161],
            [28.680185078540774, 53.95383167717512],
            [28.683222401230466, 53.95542032396787],
            [28.681881365495258, 53.95765602173793],
            [28.6781673905474, 53.962362425547724],
            [28.673024964940623, 53.96656412236558],
            [28.665025635320433, 53.968748837856936],
            [28.655597854142798, 53.96925298658482],
            [28.649026976080165, 53.967236354551744],
            [28.645884382653776, 53.96320279879495],
            [28.64302747953883, 53.95782411671854],
            [28.640170576423827, 53.95278097195734],
            [28.637027982099198, 53.94756908156501],
            [28.631599866180807, 53.94286100774815],
            [28.62331484624923, 53.941179424214965],
            [28.61417275538298, 53.94218838246894],
            [28.610458781333648, 53.94487881904257],
            [28.609887400710647, 53.95093166623883],
            [28.60960171039926, 53.95496640934874],
            [28.607030496697348, 53.95916885216525],
            [28.6030308323364, 53.96185819293862],
            [28.599316858287068, 53.96639606262488],
            [28.594174431781994, 53.968412735316804],
            [28.5844609602928, 53.969757129214145],
            [28.578175772541726, 53.970429309899885],
            [28.571890585688834, 53.973958080624186],
            [28.567033849495147, 53.97815860906286],
            [28.5618914238882, 53.9826947040832],
            [28.550463810530232, 53.98555051017934],
            [28.54017895841804, 53.98571849267552],
            [28.533893770666964, 53.983870647953665],
            [28.52618013135833, 53.980006707183975],
            [28.52212226288634, 53.976489855027125],
            [28.520752015439996, 53.9753022961595],
            [28.519037873570994, 53.96774052157616],
            [28.518180802636437, 53.96303472550102],
            [28.515895279246138, 53.959673116775434],
            [28.507895950524414, 53.95530262031963],
            [28.50075369183878, 53.95395776017017],
            [28.493897123464592, 53.95076354347049],
            [28.49218298159576, 53.9465602534533],
            [28.493897123464592, 53.94185206576236],
            [28.49761109841222, 53.938320576112346],
            [28.507324569003117, 53.936302448110894],
            [28.51389544706575, 53.935293347504455],
            [28.52303753793177, 53.93192950203331],
            [28.52360891855477, 53.924864544460775],
            [28.521894776685997, 53.920322154305154],
            [28.51846649294805, 53.914769673530486],
            [28.515323898623194, 53.909384744046974],
            [28.50761025931456, 53.904840669613804],
            [28.50218214339617, 53.9008010772684],
            [28.49532557502215, 53.899117798725854],
            [28.485612103532958, 53.89760279005412],
            [28.476184322355323, 53.89676109483338],
            [28.46447101868597, 53.89709777495631],
            [28.451043573147388, 53.897434452366326],
            [28.432759391415175, 53.89928612963189],
            [28.416189351551907, 53.899959446474156],
            [28.408475713141627, 53.9008010772684],
            [28.40104776414455, 53.902147651275016],
            [28.393334124835917, 53.90517728463357],
            [28.388477389540412, 53.905513896941045],
            [28.383049272723724, 53.9050089774629],
            [28.378478227739777, 53.90450405188153],
            [28.373050110923145, 53.905345591126434],
            [28.36819337562781, 53.908543286175416],
            [28.366193543447423, 53.91089932549602],
            [28.36476509099151, 53.914601405010615],
            [28.35962266538479, 53.918134901537655],
            [28.34790936171521, 53.92183633962719],
            [28.338481580537575, 53.92082688920067],
            [28.33333915403233, 53.918134901537655],
            [28.33076794122894, 53.915442740829235],
            [28.328196728425553, 53.911235891692456],
            [28.32333999223175, 53.90988961063266],
            [28.318197566624974, 53.9107310413807],
            [28.313912211054287, 53.91190901594854],
            [28.31048392731634, 53.911235891692456],
            [28.305912882332393, 53.908711579105955],
            [28.30305597831915, 53.907196917790486],
            [28.299056313958147, 53.904167431436804],
            [28.292199745584128, 53.8997911182808],
            [28.28820008122318, 53.89692943523403],
            [28.28162920316055, 53.89490930513796],
            [28.271630041359913, 53.89238400584344],
            [28.26534485450719, 53.890868753019106],
            [28.256774144264, 53.88817483404375],
            [28.25077464682431, 53.88514396824627],
            [28.248489124332366, 53.8812708749449],
            [28.246774982463364, 53.87672374243459],
            [28.24506084059442, 53.87268143219711],
            [28.242489626892734, 53.86880718436396],
            [28.238204272220344, 53.86712261707953],
            [28.233347536026486, 53.8698178921714],
            [28.23106201353471, 53.871839234519996],
            [28.227062349173764, 53.874702636157394],
            [28.22049147111113, 53.87840792304803],
            [28.21563473581574, 53.881607679865056],
            [28.211063689933496, 53.884470412140104],
            [28.206778335261163, 53.888343209033394],
            [28.201921599067475, 53.89002692162694],
            [28.19820762501797, 53.88918507380828],
            [28.19477934127997, 53.88766970500507],
            [28.189922605086338, 53.880597256965416],
            [28.18849415352895, 53.87672374243459],
            [28.188779843840337, 53.866280307467264],
            [28.18906553415195, 53.86088912770742],
            [28.18420879885656, 53.853980662259175],
            [28.179637752974315, 53.85246401741409],
            [28.173923946744367, 53.85044173879305],
            [28.170209971796737, 53.847913752582485],
            [28.167067378370348, 53.84353154906205],
            [28.167067378370348, 53.838643164966186],
            [28.167638758993178, 53.82819022252227],
            [28.167924449304735, 53.82110771490579],
            [28.16563892681279, 53.814698700060376],
            [28.162496332488104, 53.808963487440735],
            [28.16449616556679, 53.801034107405144],
            [28.172209803977125, 53.79597201667275],
            [28.17478101767881, 53.79192190402307],
            [28.17563808861337, 53.78483326620693],
            [28.176495159547926, 53.77639284944979],
            [28.175923778924755, 53.77301620781276],
            [28.17078135241968, 53.77250968813763],
            [28.163924784943788, 53.77352272137574],
            [28.158210977815713, 53.77554871450707],
            [28.148783196638135, 53.7752110557762],
            [28.144783532277188, 53.77352272137574],
            [28.142212318575275, 53.76980814611221],
            [28.138498344525942, 53.763560164963394],
            [28.135070060788166, 53.75866244855831],
            [28.13078470521731, 53.75612892310045],
            [28.12507089898753, 53.75443982122289],
            [28.12021416279373, 53.75494655891822],
            [28.112500523485096, 53.758324653994066],
            [28.10907223974732, 53.759675816480865],
            [28.10421550445193, 53.76170247790816],
            [28.090788058015107, 53.764235667153],
            [28.085931322719716, 53.764404541002534],
            [28.08078889621447, 53.764404541002534],
            [28.07764630278791, 53.763560164963394],
            [28.072789567492748, 53.7622091279826],
            [28.067075760364503, 53.76204024530375],
            [28.065361618495558, 53.762715771944386],
            [28.064504547561114, 53.76592437561516],
            [28.063647476626556, 53.769301587726375],
            [28.061933334757555, 53.77048354778509],
            [28.051934172956976, 53.77115893912281],
            [28.045934675517344, 53.7691327335728],
            [28.039935178077656, 53.76896387874007],
            [28.03593551371671, 53.77099009243983],
            [28.035364133093708, 53.774029228826464],
            [28.034221371847764, 53.778418704575586],
            [28.033649991224763, 53.78314531887963],
            [28.02850756471969, 53.78668992983887],
            [28.024507900358742, 53.78888406274962],
            [28.02165099724374, 53.792259428303566],
            [28.018794093230497, 53.79698448359642],
            [28.01736564167311, 53.80137155835962],
            [28.006509408938086, 53.80491462942797],
            [27.997367318071895, 53.804745918546985],
            [27.994796105268506, 53.8006966532044],
            [27.997367318071895, 53.79512827556539],
            [27.998510079317896, 53.78719627838808],
            [27.991653511841946, 53.78365171020778],
            [27.987082465959872, 53.78550842612498],
            [27.983654182221926, 53.78702749621726],
            [27.975404060161736, 53.78718472414556],
            [27.97479778166729, 53.78719627838808],
            [27.97051242609666, 53.77824988709432],
            [27.965084310178327, 53.771496630451225],
            [27.956799290246693, 53.76643097475062],
            [27.94851427031506, 53.7622091279826],
            [27.93737234726848, 53.759675816480865],
            [27.9268018048449, 53.75815575569305],
            [27.915374191486876, 53.75714235162303],
            [27.905660719997684, 53.754270907299144],
            [27.90194674594835, 53.75089248564757],
            [27.899946913767963, 53.74683802110707],
            [27.900474801969892, 53.74502733603532],
            [27.90137536532535, 53.741938355038485],
            [27.904517958751683, 53.737207100316425],
            [27.907374861866685, 53.731630294966465],
            [27.91451712055232, 53.72605274971556],
            [27.918516784913265, 53.72267205893331],
            [27.925944733910285, 53.71827675526583],
            [27.935086824776477, 53.71793863595707],
            [27.9453716768885, 53.718445813900814],
            [27.95451376775469, 53.71962920531945],
            [27.963941548932326, 53.717600513930336],
            [27.96879828422766, 53.71557172415629],
            [27.96936966485066, 53.71083750150666],
            [27.971369497929345, 53.70813199251222],
            [27.979654516962682, 53.70762469020718],
            [27.988225227205874, 53.705933638348824],
            [27.993367653710948, 53.704073402276265],
            [27.996224556825894, 53.702213084499476],
            [27.998795769629453, 53.6971390720409],
            [27.999081459940896, 53.69223361184021],
            [28.00022422118684, 53.68698921193118],
            [28.010223382987476, 53.68428216956721],
            [28.019936854476498, 53.684112973641334],
            [28.02793618409669, 53.68377457975026],
            [28.03507844278232, 53.6812365388937],
            [28.039363797454712, 53.679375211187846],
            [28.044220533648343, 53.67683690520414],
            [28.046506056140345, 53.67277529693132],
            [28.0462203658289, 53.6661743485937],
            [28.046791746451902, 53.65449321414428],
            [28.0456489852059, 53.64772005970116],
            [28.041077939323657, 53.644333074185454],
            [28.039935178077656, 53.64060707650685],
            [28.043934843336956, 53.63654197581434],
            [28.053076934202977, 53.63501746225489],
            [28.060790572613257, 53.635864421033716],
            [28.06907559254489, 53.63772767049494],
            [28.072789567492748, 53.63976021294587],
            [28.079074754345527, 53.64060707650685],
            [28.083931490539157, 53.63959083819327],
            [28.090502367703493, 53.63772767049494],
            [28.102501362582984, 53.63721951971269],
            [28.10850085912432, 53.63738890398673],
            [28.119928472482286, 53.63908270985496],
            [28.12449951836453, 53.64179265692775],
            [28.131070395528866, 53.6426394796826],
            [28.13621282203394, 53.64196202283887],
            [28.14249800888689, 53.640776447178666],
            [28.14849750632652, 53.640268333122776],
            [28.15164009975308, 53.6412845551136],
            [28.154782694077767, 53.64416371779555],
            [28.163067713111104, 53.649413450183886],
            [28.170495662108294, 53.649074777527744],
            [28.17478101767881, 53.646703992768835],
            [28.175923778924755, 53.64162329033638],
            [28.174495327367367, 53.63552563956256],
            [28.172209803977125, 53.62959652288282],
            [28.161353571242103, 53.62569979234246],
            [28.157925287504156, 53.624683194901365],
            [28.15306855131047, 53.62078601065372],
            [28.155925455323768, 53.61688846708455],
            [28.164210475255345, 53.614515872535094],
            [28.175066707990368, 53.6124821143942],
            [28.183066036712262, 53.611126221208565],
            [28.191351056643896, 53.60993977895407],
            [28.199921766886916, 53.60993977895407],
            [28.204778503080604, 53.61044825828793],
            [28.211635070556497, 53.61163468625551],
            [28.21992009048813, 53.61366848521516],
            [28.227633729796764, 53.61654953324569],
            [28.22991925228871, 53.62078601065372],
            [28.2330618457151, 53.624852629508894],
            [28.246489292151978, 53.626885791740676],
            [28.255917073329556, 53.624513759613706],
            [28.256774144264, 53.62010820283956],
            [28.254488621771998, 53.615363243380614],
            [28.249917575889924, 53.611465198586984],
            [28.249060504955366, 53.6068887738337],
            [28.253631549939314, 53.60434610162315],
            [28.263345021428336, 53.60383754881104],
            [28.272201421982913, 53.60282042428349],
            [28.283057654717936, 53.60349851020101],
            [28.28648593935418, 53.60621074287894],
            [28.290485603715126, 53.60960078932982],
            [28.29991338489276, 53.61061775003867],
            [28.304770120188095, 53.61061775003867],
            [28.311340998250728, 53.61044825828793],
            [28.319626018182362, 53.60993977895407],
            [28.32305430192031, 53.61010927274572],
            [28.328482418736996, 53.61163468625551],
            [28.33162501216333, 53.61587165740457],
            [28.33448191527833, 53.62180270250013],
            [28.33619605804563, 53.630274178327454],
            [28.342481244898522, 53.63501746225489],
            [28.345909529534595, 53.63501746225489],
            [28.352766097010544, 53.632645886681075],
            [28.35847990413879, 53.633154093088024],
            [28.359908355696177, 53.634848068458666],
            [28.366764924070424, 53.63857457486307],
            [28.373907181857703, 53.6392520866479],
            [28.378478227739777, 53.63738890398673],
            [28.383620653346725, 53.63332349368591],
            [28.39047722172097, 53.630274178327454],
            [28.394476886081748, 53.62790233665788],
            [28.394762576393305, 53.624683194901365],
            [28.39790517071799, 53.618413635685954],
            [28.39904793196399, 53.61299056311361],
            [28.40533311881694, 53.61078724110894],
            [28.41590366124052, 53.611126221208565],
            [28.4264742036641, 53.60943129349715],
            [28.43847319854342, 53.60722778522904],
            [28.43790181792042, 53.60383754881104],
            [28.428188346431227, 53.60078610281272],
            [28.418760565253592, 53.596886712264165],
            [28.41476089999452, 53.59417388083],
            [28.41647504186352, 53.588408535111114],
            [28.419331945876763, 53.58162476840454],
            [28.42675989487384, 53.57908057537048],
            [28.43561629453012, 53.578910956523714],
            [28.444758385396312, 53.579759041818306],
            [28.46018566401341, 53.579589426227244],
            [28.4681849936336, 53.579589426227244],
            [28.47504156110938, 53.57755398551649],
            [28.475898632043936, 53.57297388679348],
            [28.47846984574562, 53.56924158712235],
            [28.48732624540196, 53.56873261171654],
            [28.498753859658393, 53.56788430576074],
            [28.506753188380117, 53.567035982788866],
            [28.51789511232505, 53.561097244990094],
            [28.531322557863575, 53.554648527913685],
            [28.546269400777703, 53.545439373576585],
            [28.56374740162147, 53.546383470920546],
            [28.57626869214647, 53.547977683823206],
            [28.587001226625375, 53.550103207197424],
            [28.591473117190787, 53.558604232299615],
            [28.592367494764176, 53.566572392002286],
            [28.603100029243137, 53.56869698188018],
            [28.61204380857498, 53.56869698188018],
            [28.615621320667458, 53.57719427119878],
            [28.619198831860672, 53.58728258442392],
            [28.626353855146363, 53.59630692952129],
            [28.633508878432053, 53.60055301381061],
            [28.643347035337513, 53.60161446833308],
            [28.654079570715624, 53.59789926104213],
            [28.663023350047695, 53.59418372819664],
            [28.674650262100045, 53.59099872521119],
            [28.688960309570803, 53.587813482106526],
            [28.698798465576886, 53.58356611808199],
            [28.704164733715572, 53.57772529478672],
            [28.709531001854373, 53.57029035301747],
            [28.739045472570695, 53.56763469998151],
            [28.7587217863815, 53.56975923590005],
            [28.778398100192305, 53.57400798757874],
            [28.778398100192305, 53.58409706163013],
            [28.78465874590455, 53.58834437259475],
            [28.79360252523645, 53.588875255888524],
            [28.805229438188178, 53.588875255888524],
            [28.818645106286738, 53.594714538645235],
            [28.825800130471805, 53.58993700359002],
            [28.828483264091403, 53.58197324606846],
            [28.831166396811852, 53.57560115906642],
            [28.83832142099692, 53.57241475583646],
            [28.847265199429444, 53.57241475583646],
            [28.858036397539422, 53.57217786506459],
          ],
        ],
      },
      properties: {
        shapeName: "Chervyen",
        shapeISO: "",
        shapeID: "67162791B52884935059856",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
